<template>
    <div class="page-layout blank contacts-manage">
        <div class="pb-10 pl-3 pr-3">
            <h2 class="ml-0 mb-0 mt-0">
                <!-- <div class="d-flex flex-wrap justify-content-between">
                    <div class="breadcrumbactive">
                        <div>
                            <span>Campaigns</span>
                            <span><router-link to="/campaign/email/campaignEmailListView/" class="text-white pl-2 text-line">Email</router-link></span>
                            <div>View Campaign</div>
                        </div>
                    </div>
                </div> -->

                <div class="d-flex flex-wrap justify-content-between align-items-center">
                    <!-- Breadcrumb Section -->
                    <div class="breadcrumbactive">
                        <div>
                            <span>Campaigns</span>
                            <span><router-link to="/campaign/email/campaignEmailListView/" class="text-white pl-2 text-line">Email</router-link></span>
                            <div>View Campaign</div>
                        </div>
                    </div>
                    <div class="d-flex flex-wrap align-items-center" v-if="!ajaxCallInProgress">
                        <button class="btn btn-new-primary btn-wide px-4 mr-4" v-if="userPermissions.campaigns.permitted_actions.edit && campaign_details.status != 'approved'" @click="gotoEdit()"><img src="/static/images/images-new-theme/icons/edit-white.png" width="15" style="margin-right: 8px;"> Edit</button>
                        <!-- <button class="btn btn-new-green btn-wide px-6 text-capitalize" :class="{
                                    'btn-pending':campaign_details.status == 'pending',
                                    'btn-approved':campaign_details.status == 'approved',
                                    'btn-rejected':campaign_details.status == 'rejected'}">{{campaign_details.status}}</button> -->
                        <span class="fs-16 text-capitalize"
                        :class="{
                            'text-pending':campaign_details.status == 'pending',
                            'text-approved':campaign_details.status == 'approved',
                            'text-new-danger':campaign_details.status == 'rejected'}"
                        >Status : {{campaign_details.status}}</span>
                    </div>
                </div>
            </h2>
            <div class="d-flex align-items-center justify-content-center h-100" v-if="ajaxCallInProgress">
                <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
            </div>
            <!-- Campaign Input Section -->
            <div v-else class="start-overflow">
                <div class="create-company-container w-100">
                    <div class="main-div">
                        <div class="px-10 py-4" v-if="campaign_details.status == 'rejected'">
                            <div class="p-2" style="border: 1px solid #e64646;border-radius:10px;height:186px;">
                                <span class="fs-14 fw-500 text-new-danger">Reason for Rejection</span>
                                <div class="pt-2">
                                    <span class="fs-14">{{campaign_details.rejected_reason}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="create-company-header d-flex align-items-center justify-content-between">
                            <span class="fs-14  pl-4 text-white ml-8 fw-500">Campaign Information</span>
                        </div>
                        <div>
                            <div class="mt-6 px-10" >
                                <div class="pt-6 pl-6 pr-6 pb-2">
                                    <div class="row">
                                        <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div class="w-100">
                                                <span class="input-label">Campaign Name</span>
                                                <div class="d-flex align-content-center mt-2">
                                                    <input type="text" name="campaign_name" disabled class="input-field input-width" v-model="createJson.campaign_name" placeholder="Sample Campaign Name" />
                                                </div>
                                                <!-- <div class="text-right pr-10">
                                                    <span class="float-left text-danger mb-3" v-show="errors.has('campaign_name')">Campaign Name is required</span>
                                                </div> -->
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div class="w-100">
                                                <span class="input-label">Author Name</span>
                                                <div class="d-flex align-content-center mt-2">
                                                    <input type="text" name="author_name" disabled class="input-field input-width" v-model="createJson.author_name" placeholder="Author Name" />
                                                    <span class="mt-4 ml-1">
                                                        <span class="mt-3"><i class="icon text-green icon-check-circle"></i></span>
                                                    </span>
                                                </div>
                                                <!-- <div class="text-right pr-10">
                                                    <span class="float-left text-danger mb-3" v-show="errors.has('author_name')">Author Name is Required</span>
                                                </div> -->
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div class="w-100">
                                                <span class="input-label">Author's Email Address</span>
                                                <div class="d-flex align-content-center mt-2">
                                                    <input type="text" name="author_email" disabled class="input-field input-width" v-model="createJson.author_email" placeholder="Author Name" />
                                                    <span class="mt-4 ml-1">
                                                        <span class="mt-3"><i class="icon text-green icon-check-circle"></i></span>
                                                    </span>
                                                </div>
                                                <!-- <div class="text-right pr-10">
                                                    <span class="float-left text-danger mb-3" v-show="errors.has('author_email')">Author's Email is Required</span>
                                                </div> -->
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-5">
                                        <!-- <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div class="d-flex align-items-center">
                                                <div class="w-100">
                                                    <span class="input-label">Industry Type</span>
                                                    <multiselect v-validate="'required'"
                                                        class="diginew-multiselect new-align-multi customer-multiselect no-default-icon down-arrow mt-2"
                                                        :disabled="true"
                                                        :searchable="true" :options="industries" name="industry_type"
                                                        v-model="createJson.industry_type" placeholder="Select Industry Type">
                                                        <template slot="noOptions">
                                                            <div class="text-secondary text-center fw-600">Industry Types not found
                                                            </div>
                                                        </template>
                                                        <template slot="noResult">
                                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                                        </template>
                                                    </multiselect>
                                                    <div class="text-right pr-10">
                                                        <span class="float-left text-danger mb-3"
                                                            v-show="errors.has('industry_type')">Industry Type is Required</span>
                                                    </div>
                                                </div>
                                                <span class="mt-8">
                                                    <i class="icon icon-check-circle fs-30 ml-2 text-green"></i>
                                                </span>
                                            </div>
                                        </div> -->
                                        <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div class="w-100">
                                                <span class="input-label">Campaign Type</span>
                                                <div class="d-flex align-content-center mt-2">
                                                    <input type="text" name="campaign_type" disabled class="input-field input-width text-capitalize" v-model="createJson.campaign_type" placeholder="Campaign Type" />
                                                    <span class="mt-4 ml-1">
                                                        <span class="mt-3"><i class="icon text-green icon-check-circle"></i></span>
                                                    </span>
                                                </div>
                                                <!-- <div class="text-right pr-10">
                                                    <span class="float-left text-danger mb-3" v-show="errors.has('campaign_type')">Campaign Type is Required</span>
                                                </div> -->
                                            </div>
                                        </div>
                                        <!-- <div class="col-lg-4 col-md-6 col-sm-12">
                                            <div class="row">
                                                <div class="col-lg-3 col-md-3 col-sm-6">
                                                    <span class="input-label">
                                                        Budget
                                                    </span>
                                                    <div class="d-flex align-items-center mt-2">
                                                        <input type="text" name="currency" disabled v-model="createJson.currency" class="input-field input-width text-center"  placeholder="$" />
                                                    </div>
                                                </div>
                                                <div class="col-lg-9 col-md-9 col-sm-6 pl-2">
                                                   <span class="input-label" style="visibility: hidden;">
                                                        Budget
                                                    </span>
                                                    <div class="d-flex align-items-center mt-2">
                                                        <input type="number" name="budget" class="input-field input-width" disabled v-model="createJson.budget" placeholder="Enter Budget Value" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div> -->
                                        <div class="col-lg-4 col-md-6 col-sm-12">
                                            <!-- <div class="row">
                                                <div class="col-lg-8 col-md-8 col-sm-6"> -->
                                                    <span class="input-label">
                                                        Broadcast
                                                    </span>
                                                    <div class="d-block align-items-center mt-1">
                                                        <multiselect
                                                            class="diginew-multiselect new-align-multi customer-multiselect no-default-icon down-arrow mt-2"
                                                            :searchable="true" :options="recurrencedays" name="recurrence_days"
                                                            :disabled="true"
                                                            v-model="createJson.recurrence_days" placeholder="Select">
                                                            <template slot="noOptions">
                                                                <div class="text-secondary text-center fw-600">Recurrence not found
                                                                </div>
                                                            </template>
                                                            <template slot="noResult">
                                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                                            </template>
                                                        </multiselect>

                                                    </div>
                                                <!-- </div> -->
                                                <!-- <div class="col-lg-4 col-md-4 col-sm-6 pl-2">
                                                    <span class="input-label" style="visibility: hidden;">
                                                        Recurrence
                                                    </span>
                                                    <div class="d-block align-items-center mt-1">
                                                        <multiselect
                                                            class="diginew-multiselect new-align-multi customer-multiselect no-default-icon down-arrow mt-2"
                                                            :searchable="true" :options="recurrencenumbers" name="recurrence_nos"
                                                            v-model="recurrence_nos" placeholder="Select">
                                                            <template slot="noOptions">
                                                                <div class="text-secondary text-center fw-600">Recurrence not found
                                                                </div>
                                                            </template>
                                                            <template slot="noResult">
                                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                                            </template>
                                                        </multiselect>

                                                    </div>
                                                </div> -->
                                            <!-- </div> -->
                                        </div>


                                    </div>
                                    <div class="row mt-5">
                                        <div class="col-lg-4 col-md-6 col-sm-12">
                                            <div class="row">
                                                <div class="col-lg-12 col-md-12 col-sm-12">
                                                    <span class="input-label">
                                                        Broadcast Start Date
                                                    </span>
                                                    <div class="d-flex align-items-center mt-2">
                                                        <date-picker v-model="createJson.start_date" name="start_date"
                                                            class="meetinfdatetime mx-left calendar-edit-per mr-1"
                                                            format="YYYY-MM-DD" :disabled="true" value-type="format" type="date" lang="en"
                                                            :clearable="false" :editable="false" confirm confirm-text="APPLY">
                                                        </date-picker>
                                                        <span class="mt-3"><i class="icon text-green icon-check-circle"></i></span>
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger" v-if="is_start_date">
                                                        Start Date is required.
                                                    </span>
                                                </div>
                                                <!-- <div class="col-lg-4 col-md-4 col-sm-6 pl-1">
                                                    <span class="input-label">
                                                      Time
                                                    </span>
                                                    <div class="d-flex align-items-center mt-2">
                                                        <date-picker
                                                            :disabled="true"
                                                            type="time"
                                                            v-model="createJson.start_time"
                                                            name="start_time"
                                                            class="meetinfdatetime mx-left calendar-edit-per mr-1 calendar-down-arrow-grey no-down-arrow-autofill"
                                                            format="HH:mm"
                                                            placeholder="HH:MM"
                                                            value-type="format"
                                                            lang="en"
                                                            :clearable="false"
                                                            :editable="false"
                                                            confirm
                                                            confirm-text="APPLY">
                                                        </date-picker>
                                                        <span class="mt-3"><i class="icon text-green icon-check-circle"></i></span>
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger" v-if="is_start_date">Start Time is required.</span>
                                                </div> -->
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-6 col-sm-12">
                                            <div class="row">
                                                <div class="col-lg-12 col-md-12 col-sm-12">
                                                    <span class="input-label">
                                                        Broadcast End Date
                                                    </span>
                                                    <div class="d-flex align-items-center mt-2">
                                                        <date-picker v-model="createJson.end_date"
                                                        name="closure_date" class="meetinfdatetime mx-left calendar-edit-per mr-1 calendar-edit-per mr-1 "
                                                        format="YYYY-MM-DD" value-type="format" type="date" lang="en"
                                                        :disabled="true"
                                                        :clearable="false"
                                                        :default-value="current_date"
                                                        :not-before="current_date"
                                                        :editable="false" confirm confirm-text="APPLY"></date-picker>
                                                    </div>
                                                    <!-- <span class="invalid-feedback-form text-danger" v-if="is_end_date && createJson.end_date == ''"> End Date is required.</span> -->
                                                </div>
                                                <!-- <div class="col-lg-4 col-md-4 col-sm-6 pl-1">
                                                    <span class="input-label">
                                                        Broadcast Time
                                                    </span>
                                                    <div class="d-flex align-items-center mt-2">
                                                        <date-picker
                                                        v-model="createJson.end_time"
                                                        type="time" name="end_time"
                                                        v-validate="'required'"
                                                        class="meetinfdatetime mx-left calendar-edit-per mr-1 calendar-down-arrow-grey hide-seconds date-picker-clock-svg-icon"
                                                        format="HH:mm"
                                                        :disabled="true"
                                                        :minute-step="1"
                                                        placeholder="HH:MM"
                                                        value-type="format"
                                                        lang="en"
                                                        :clearable="false"
                                                        :editable="false"
                                                        confirm
                                                        confirm-text="APPLY">
                                                    </date-picker>
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger" v-if="is_end_time && createJson.end_time == ''">
                                                        End Time is required.
                                                    </span>
                                                </div> -->
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-6 col-sm-12 pl-4">
                                            <span class="input-label">
                                                Broadcast Time
                                            </span>
                                            <div>
                                               <date-picker
                                                    :disabled="true"
                                                    type="time"
                                                    v-model="createJson.start_time"
                                                    name="start_time"
                                                    class="meetinfdatetime mx-left calendar-edit-per mr-1 calendar-down-arrow-grey no-down-arrow-autofill mt-2"
                                                    format="HH:mm"
                                                    placeholder="Select Time"
                                                    value-type="format"
                                                    lang="en"
                                                    :clearable="false"
                                                    :editable="false"
                                                    confirm
                                                    confirm-text="APPLY">
                                                </date-picker>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-4 ml-0">
                                        <label class="custom-control custom-checkbox digi-checkbox fs-14 fw-600" style="padding-right: 0px !important;">
                                            <input type="checkbox" v-model="createJson.send_now" disabled class="custom-control-input" />Send Now
                                            <span class="custom-control-indicator" style="font-size: 20px; top: -10px !important;"></span>
                                            <span class="form-check-description fw-600"></span>
                                        </label>
                                    </div>
                                    <div class="row mt-5">
                                        <div class="col-lg-2 col-md-6 col-sm-12">
                                            <span class="input-label">
                                                Template
                                            </span>
                                            <div class="d-flex align-items-center mt-5">
                                                        <!-- <div class="outer-checkbox">
                                                            <div class="inner-checkbox">
                                                                <input type="checkbox" id="template-image" />
                                                                <label for="template-image" />
                                                                <img src="/static/images/suitcase.jpg" alt="">
                                                            </div>
                                                        </div> -->
                                                <div class="row">
                                                    <!-- <div class="col-md-4">
                                                        <div class="custom-control custom-checkbox-image image-checkbox">
                                                            <input type="radio" class="custom-control-input" id="ck1a +'index'" name="radioImg" v-model="createJson.selectedtemplate" value="template1">
                                                            <label class="custom-control-label-image" for="ck1a +'index'">
                                                                <img src="/static/images/template1.webp" name="imgTemp"  alt="#" class="img-fluid img">
                                                                <div class="middle" @click="previewImage(image)">
                                                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/show-password.svg" class="icon-css" >
                                                                    <img :src="image.url1" alt="" style="display: none;">
                                                                </div>
                                                            </label>
                                                        </div>
                                                        <h5 class="templateimage-name">Be Descriptive </h5>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <div class="custom-control custom-checkbox-image image-checkbox">
                                                            <input type="radio" class="custom-control-input" id="ck1b +'index'" name="radioImg" v-model="createJson.selectedtemplate" value="template2">
                                                            <label class="custom-control-label-image" for="ck1b +'index'">
                                                                <img src="/static/images/template2.webp" name="imgTemp"  alt="#" class="img-fluid img">
                                                                <div class="middle" @click="previewImage(image)">
                                                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/show-password.svg" class="icon-css" >
                                                                    <img :src="image.url2" alt="" style="display: none;">
                                                                </div>
                                                            </label>
                                                        </div>
                                                        <h5 class="templateimage-name">Make Offer </h5>
                                                    </div> -->
                                                    <div class="col-md-9" style="max-width: 100%;">
                                                        <div class="custom-control custom-checkbox-image image-checkbox">
                                                            <input type="image" class="custom-control-input" id="ck1c +'index'" name="radioImg" v-model="createJson.selectedtemplate">
                                                            <label class="custom-control-label-image" for="ck1c +'index'">
                                                                <img src="/static/images/template3.webp" name="imgTemp"  alt="#" class="img-fluid img">
                                                                <div class="middle" @click="previewImage(image)">
                                                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/show-password.svg" class="icon-css" >
                                                                    <img :src="image.url3" alt="" style="display: none;">
                                                                </div>
                                                            </label>
                                                        </div>
                                                        <h5 class="templateimage-name">Advertised Yours </h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-10 col-md-6 col-sm-12">
                                            <span class="input-label">
                                                Description
                                            </span>
                                            <div class="d-flex align-items-center mt-2">
                                                <textarea-autosize class="digi-textarea white-background bordered" placeholder="Add Description" disabled v-model="createJson.description" style="height: 10em; overflow: auto;" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-5">
                                        <div class="col-lg-12 col-md-12 col-sm-12">
                                            <span class="input-label">
                                                Recipients
                                                <!-- <button class="float-right mr-8 add-button" @click="contactsPop()">
                                                    Add+
                                                </button> -->
                                            </span>
                                            <div class="d-flex align-items-center mt-2">
                                                <div class="recipients-box">
                                                    <multiselect
                                                        class="diginew-multiselect-longshort greyblack no-default-icon mt-3"
                                                        name="recipients"
                                                        :disabled="true"
                                                        @search-change="searchCustomerInside"
                                                        @open="searchCustomerInside"
                                                        @close="search_term = ''"
                                                        :loading="isLoading"
                                                        v-model="createJson.recipient_details"
                                                        :searchable="true" :block-keys="['Tab']"
                                                        :preserve-search="true"
                                                        placeholder="Select Recipients"
                                                        :options="optionsRecipients"
                                                        :multiple="true"
                                                        :close-on-select="false"
                                                        :show-labels="false"
                                                        :clear-on-select="true"
                                                        :hide-selected="false" :taggable="true"
                                                        label="email" track-by="email"
                                                        @tag="addCustomer">
                                                        <template slot="tag"
                                                            slot-scope="{ option, remove }">
                                                            <span class="custom__tag">
                                                                <span>{{ option.email }}</span>
                                                                <span class="custom__remove"
                                                                    @click="remove(option)">
                                                                    <i
                                                                        class="icon-close iconsize-16 defaultDarkBlue"></i>
                                                                </span>
                                                            </span>
                                                        </template>
                                                        <template slot="afterList">
                                                            <div
                                                                v-observe-visibility="reachedEndOfListCustomer" />
                                                        </template>
                                                        <template slot="noOptions">
                                                            <div
                                                                class="text-secondary text-center fw-600">
                                                                List is Empty</div>
                                                        </template>
                                                        <template slot="noResult">
                                                            <div
                                                                class="text-secondary text-center fw-600">
                                                                No Results Found</div>
                                                        </template>
                                                    </multiselect>
                                                    <!-- <div class="text-right mt-1">

                                                        <span class="float-left text-danger mb-3" v-show="errors.has('recipients')">Recipients are Required</span>
                                                    </div> -->
                                                </div>
                                                <span class="mt-3 ml-1">
                                                    <img src="/static/images/person-add-green.svg" style="width: 16px;"/>
                                                </span>
                                                <sup style="color:#008a63;font-size: 11px;font-weight: 600;">{{ this.createJson.recipient_details.length }}</sup>

                                            </div>
                                        </div>
                                        <div class="col-lg-12 col-md-12 col-sm-12 mt-5">
                                            <span class="input-label">
                                                Other Recipients
                                            </span>
                                            <div class="d-flex align-items-center mt-2">
                                                <div class="recipients-box">
                                                    <vue-tags-input class="input-height email-text-valid" v-validate="'email'"
                                                        name="other_recipient" placeholder=""
                                                        v-model="tag" :disabled="true"
                                                        :tags="tags"
                                                        @tags-changed="newTags => tags = newTags"
                                                    />
                                                </div>
                                                <span class="mt-3 ml-1">
                                                    <img src="/static/images/person-add-green.svg" style="width: 16px;"/>
                                                </span>
                                                <sup style="color:#008a63;font-size: 11px;font-weight: 600;">{{ this.tags.length }}</sup>
                                            </div>
                                            <span class="text-danger float-left mt-2 pl-2" v-show="errors.has('other_recipient')" style="text-transform: none !important;">Please Enter Valid Email Address</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="pt-3 px-17" >
                                <div class="create-company-header d-flex align-items-center justify-content-between">
                                    <span class="fs-14 text-white ml-1 fw-500">Add Template Details</span>
                                </div>
                                <div v-for="(template_data, template_index) in template_details" :key="template_index" class="content-details-div pt-1">
                                    <div class="mt-5 w-100 h-line">
                                        <span class="h-label text-black">Content Details (<span v-for="(date, date_index) in template_data.template_dates" :key="date_index">{{date}}<span v-if="date_index != (template_data.template_dates.length -1)">; </span></span>)</span>
                                    </div>
                                    <div class="mt-5 w-100 h-line">
                                        <span class="h-label">Info</span>
                                    </div>
                                    <div class="row mt-7">
                                        <div class="col-lg-8 col-md-8 col-sm-12">
                                            <div class="d-flex align-items-center">
                                                <div class="w-100">
                                                    <span class="input-label">Topic Name</span>
                                                    <div class="d-flex align-content-center mt-2">
                                                        <input type="text" name="topic_name" disabled maxlength="100" class="input-field input-width text-capitalize"  v-model="template_data.topic_name" placeholder="Enter Topic Name" />
                                                    </div>
                                                    <!-- <div class="text-right mt-1">
                                                        <span class="input-field-length float-right">{{ createJson.topic_name.length }}/100</span>
                                                        <span class="float-left text-danger mb-3" v-show="errors.has('topic_name')">Topic Name is Required</span>
                                                    </div> -->
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div class="d-flex align-items-center">
                                                <div class="w-100">
                                                    <span class="input-label">Hyperlink Button Name</span>
                                                    <div class="d-flex align-content-center mt-2">
                                                        <input type="url" name="headline_url" disabled maxlength="50" class="input-field input-width text-capitalize"  v-model="template_data.headline_url" placeholder="Enter URL Headline" />
                                                    </div>
                                                    <!-- <div class="text-right mt-1">
                                                        <span class="input-field-length float-right">{{ createJson.headline_url.length }}/50</span>
                                                    </div> -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-4">
                                        <div class="col-lg-8 col-md-8 col-sm-12">
                                            <div class="d-flex align-items-center">
                                                <div class="w-100">
                                                    <span class="input-label">Headline</span>
                                                    <div class="d-flex align-content-center mt-2">
                                                        <input type="text" name="headline" disabled maxlength="100" class="input-field input-width text-capitalize"  v-model="template_data.headline" placeholder="Headline" />
                                                    </div>
                                                    <!-- <div class="text-right mt-1">
                                                        <span class="input-field-length float-right">{{ createJson.headline.length }}/100</span>
                                                    </div> -->
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div class="d-flex align-items-center">
                                                <div class="w-100">
                                                    <span class="input-label">Add Hyperlink to button</span>
                                                    <div class="d-flex align-content-center mt-2">
                                                        <input type="url" name="add_url" disabled maxlength="40" class="input-field input-width"  v-model="template_data.add_url" placeholder="Add URL" />
                                                    </div>
                                                    <!-- <div class="text-right mt-1">
                                                        <span class="input-field-length float-right">{{ createJson.add_url.length }}/50</span>
                                                    </div> -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-4">
                                        <div class="col-lg-8 col-md-8 col-sm-12">
                                            <div class="d-flex align-items-center">
                                                <div class="w-100">
                                                    <span class="input-label">Content</span>
                                                    <div class="d-flex align-content-center mt-2">
                                                        <input type="text" name="content" disabled class="input-field input-width" :title="template_data.content" v-model="template_data.content" placeholder="Content" />
                                                    </div>
                                                    <!-- <div class="text-right mt-1">
                                                        <span class="input-field-length float-right">{{ 100 - createJson.content.length }}/100</span>
                                                    </div> -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mt-6" >
                                        <div class="mt-5 w-100 h-line">
                                            <span class="h-label">Address Details</span>
                                        </div>
                                        <div class="row mt-7">
                                            <div class="col-lg-4 col-md-4 col-sm-12">
                                                <div class="w-100">
                                                    <span class="input-label">Phone Number</span>
                                                    <div class="d-flex align-items-center">
                                                        <div class="w-100">
                                                            <vue-tel-input :defaultCountry="template_data.phone_number.country_code|| 'US'"
                                                                v-bind="bindProps"
                                                                class="number-field-width-customer teleContactborderedDark new-align-tel ml-0 mt-3"
                                                                name="campaign_mobile_number"
                                                                disabled
                                                                v-model="template_data.phone_number.number"
                                                                :valid-characters-only="true" :maxLen="15"
                                                                placeholder="Enter Mobile Number" :disabledFormatting="false"
                                                                style="width:100% !important; margin-right: 30px;">
                                                            </vue-tel-input>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-8 col-md-8 col-sm-12">
                                                <span class="input-label">Location</span>
                                                <div class="d-flex align-items-center mt-3">
                                                    <div class="form-group pt-0 gMap" style="width:180em;">
                                                        <gmap-autocomplete
                                                            class="input-white"
                                                            id="autocompleteInput"
                                                            name="get_location"
                                                            :disabled="true"
                                                            placeholder="Search Location"
                                                            @place_changed="setPlace"
                                                            :value="template_data.meeting_location_vmodel"
                                                            v-model="template_data.meeting_location_vmodel"
                                                            style="padding: 6px 32px 6px 12px !important;background-color: #eff3f9">
                                                        </gmap-autocomplete>
                                                        <el-tooltip class="item"
                                                            effect="dark"
                                                            :content="template_data.meeting_location_vmodel"
                                                            placement="top">
                                                            <img src="/static/images/images-new-theme/icons/marker_pin.svg"
                                                                style="position: absolute;right: 12px;bottom: 10px;" />
                                                        </el-tooltip>
                                                    </div>
                                                    <div class="ml-3" style="width:10%;">
                                                        <img src="/static/images/images-new-theme/icons/GPS 2.svg" style="height: 40px;" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <div class="row mt-3">
                                            <div class="col-lg-4 col-md-4 col-sm-12">
                                                <div class="d-flex align-items-center">
                                                    <div class="w-100">
                                                        <span class="input-label">Street</span>
                                                        <div class="d-flex align-content-center mt-2">
                                                            <input type="text" name="street" disabled class="input-field input-width"  v-model="createJson.street" placeholder="Address" />
                                                        </div>
                                                        </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-4 col-md-4 col-sm-12">
                                                <div>
                                                    <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">Country</span>
                                                    <div class="d-flex align-items-center">
                                                        <div class="w-100" >
                                                            <multiselect class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-2" name="country" :searchable="true" :disabled="true" :options="countries"  v-validate="'required'" v-model="location.country" @select="resetData" placeholder="Select Country">
                                                                <template slot="noOptions">
                                                                    <div class="text-secondary text-center fw-600">Countries Not Found</div>
                                                                </template>
                                                                <template slot="noResult">
                                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                                </template>
                                                            </multiselect>
                                                            <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-show="errors.has('country')">Country is required</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-4 col-md-4 col-sm-12">
                                                <div class="d-flex align-items-center">
                                                    <div class="w-100">
                                                        <span class="input-label">State</span>
                                                        <div class="d-flex align-content-center mt-2">
                                                            <input type="text" name="state" disabled class="input-field input-width"  v-model="createJson.state" placeholder="State" />

                                                        </div>
                                                        </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-5">
                                            <div class="col-lg-4 col-md-4 col-sm-12">
                                                <div class="d-flex align-items-center">
                                                    <div class="w-100">
                                                        <span class="input-label">City</span>
                                                        <div class="d-flex align-content-center mt-2">
                                                            <input type="text" name="city" maxlength="15" disabled class="input-field input-width"  v-model="createJson.city" placeholder="City" />
                                                        </div>
                                                        <div class="text-right mt-1">
                                                            <span class="input-field-length float-right">{{ createJson.city.length }}/15</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-4 col-md-4 col-sm-12">
                                                <div class="d-flex align-items-center">
                                                    <div class="w-100">
                                                        <span class="input-label">Township</span>
                                                        <div class="d-flex align-content-center mt-2">
                                                            <input type="text" name="content" maxlength="15" disabled class="input-field input-width"  v-model="createJson.township"  placeholder="Township" />
                                                        </div>
                                                        <div class="text-right mt-1">
                                                            <span class="input-field-length float-right">{{ createJson.township.length }}/15</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-4 col-md-4 col-sm-12">
                                                <div class="d-flex align-items-center">
                                                    <div class="w-100">
                                                        <span class="input-label">Pincode</span>
                                                        <div class="d-flex align-content-center mt-2">
                                                            <input type="text" name="pincode" maxlength="10" disabled class="input-field input-width"  v-model="createJson.pincode"  placeholder="Pincode" />
                                                        </div>
                                                        <div class="text-right mt-1">
                                                            <span class="input-field-length float-right">{{ createJson.pincode.length }}/10</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> -->
                                    </div>
                                    <div class="mt-6" >
                                        <div class="mt-5 w-100 h-line">
                                            <span class="h-label">Social Media URLs</span>
                                        </div>
                                        <div class="row mt-3">
                                            <div class="col-lg-3 col-md-3 col-sm-12">
                                                <div class="d-flex align-items-center mt-2">
                                                    <input type="url" name="facebook_url" disabled class="input-field icon-data icon-face-link input-width" :title="template_data.facebook_url" v-model="template_data.facebook_url" placeholder="Add URL" />
                                                </div>
                                            </div>
                                            <div class="col-lg-3 col-md-3 col-sm-12">
                                                <div class="d-flex align-items-center mt-2">
                                                    <input type="url" name="twitter_url" disabled class="input-field icon-data icon-twit-link input-width" :title="template_data.twitter_url" v-model="template_data.twitter_url" placeholder="Add URL" />
                                                </div>
                                            </div>
                                            <div class="col-lg-3 col-md-3 col-sm-12">
                                                <div class="d-flex align-items-center mt-2">
                                                    <input type="url" name="insta_url" disabled class="input-field icon-data icon-insta-link input-width" :title="template_data.insta_url" v-model="template_data.insta_url" placeholder="Add URL" />
                                                </div>
                                            </div>
                                            <div class="col-lg-3 col-md-3 col-sm-12">
                                                <div class="d-flex align-items-center mt-2">
                                                    <input type="url" name="linkedin_url" disabled class="input-field icon-data icon-link input-width" :title="template_data.linkedin_url" v-model="template_data.linkedin_url" placeholder="Add URL" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mt-6" >
                                        <div class="mt-5 w-100 h-line">
                                            <span class="h-label">Add Images</span>
                                        </div>
                                        <div class="row mt-5">
                                            <div v-if="template_data.logoImage.length == 0" class="col-lg-6 col-md-6 col-sm-6">
                                                <div class="mt-5 col-md-offset-2 flex-width">
                                                    <div class="stage-sections">
                                                        <span class="fw-500">Logo</span>
                                                        <div class="overflow-auto mx-ht">
                                                            <div class="text-center pt-50 fw-500 fs-16" style="padding-top: 50px !important;padding-bottom: 60px !important;">No Logo Image</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else class="col-lg-6 col-md-6 col-sm-6">
                                                <div class="mt-5 col-md-offset-2 flex-width">
                                                    <div class="stage-sections">
                                                        <span class="fw-500">Logo</span>
                                                        <div class="overflow-auto mx-ht mt-3">
                                                        <div class="p-4" v-for="attachment in template_data.logoImage"  :key="attachment.name">
                                                                <span class="_images pointer" style="position: relative;" @click="previewImage(attachment)">
                                                                    <img class="att-img pointer" :src="attachment.url" alt="">
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="template_data.bannerImage.length == 0" class="col-lg-6 col-md-6 col-sm-6">
                                                <div  class="mt-5 col-md-offset-2 flex-width">
                                                    <div class="stage-sections">
                                                            <span class="fw-500">Banner Image</span>
                                                            <div class="overflow-auto mx-ht">
                                                                <div class="text-center pt-50 fw-500 fs-16" style="padding-top: 50px !important;padding-bottom: 60px !important;">No Banner Image</div>
                                                            </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else class="col-lg-6 col-md-6 col-sm-6">
                                                <div class="mt-5 col-md-offset-2 flex-width">
                                                    <div class="stage-sections">
                                                        <span class="fw-500">Banner Image</span>
                                                        <div class="overflow-auto mx-ht mt-3">
                                                            <div class="p-4" v-for="attachment in template_data.bannerImage"
                                                                :key="attachment.name">
                                                                <span  class="_images pointer" style="position: relative;" @click="previewImage(attachment)">
                                                                    <img class="att-img pointer" :src="attachment.url" alt="">
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="pt-5 px-17">
                                <div class="create-company-header d-flex align-items-center justify-content-between">
                                    <span class="fs-14 text-white ml-1 fw-500">Attachments</span>
                                </div>
                                <div class="pt-2 py-2 fs-14 text-black fw-500 text-center" v-if="attachmentNew.length == 0">
                                    No Attachments Added!
                                </div>
                                <div class="pt-2 row" v-if="attachmentNew.length > 0"
                                    style="">
                                    <div class="p-4 my-2 col-6"
                                        v-for="(attachment,index) in attachmentNew"
                                        :key="index">
                                        <div class="attachmentsdiv p-3">
                                            <div
                                                class="d-flex align-items-center justify-content-between">
                                                <div class="d-flex align-items-center">
                                                    <div>
                                                        <img class="icon-img"
                                                            v-if="attachment.name.endsWith('.pdf')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/pdf-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.png')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/png-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.jpg')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg.png" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.svg')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/svg-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.xls')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/xls-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.doc')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/doc-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.docx')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/docx-icon.svg" />
                                                        <!-- <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.htm')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/htm-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.html')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/html-icon.svg" /> -->
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.ppt')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/ppt-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.pptx')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/pptx-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.txt')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/txt-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.xlsx')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/xlsx-icon.svg" />
                                                        <!-- <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.bmp')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/bmp-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.gif')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/gif-icon.svg" /> -->
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.jpeg')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg-icon.svg" />
                                                        <!-- <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.tiff')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg.png" /> -->
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.avi')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/avi-icon.svg" />
                                                        <!-- <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.flv')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/flv-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.mpg')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mpg-icon.svg" /> -->
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.mpeg')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mpeg-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.mp3')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mp3-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.mp4')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mp4-icon.svg" />
                                                        <!-- <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.wav')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/wav-icon.svg" />
                                                        <img class="icon-img"
                                                            v-else-if="attachment.name.endsWith('.wmv')"
                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/wmv-icon.svg" /> -->
                                                    </div>
                                                    <div class="col">
                                                        <div
                                                            class="d-flex justify-content-between">
                                                            <el-tooltip
                                                                :content="attachment.name"
                                                                placement="top">
                                                                <div
                                                                    class="font-weight-bold text-truncate d-block mx-width-220">
                                                                    {{attachment.name}}</div>
                                                            </el-tooltip>
                                                        </div>
                                                        <div
                                                            v-if="attachment.uploading || attachment.url == undefined">
                                                            <progress-bar
                                                                class="progressBar w-100"
                                                                :class="{'error-upload':attachment.url == undefined}"
                                                                :val="attachment.progress"
                                                                size="small"></progress-bar>
                                                        </div>
                                                        <div
                                                            class="d-flex justify-content-between">
                                                            <div class="text-danger pl-0 fw-500"
                                                                v-if="attachment.error != ''">
                                                                {{attachment.error}}...</div>
                                                            <div class="text-secondary fw-500"
                                                                v-if="attachment.progress<100 && attachment.error == ''">
                                                                {{attachment.progress}}%
                                                                Uploading</div>
                                                            <div class="text-secondary fw-500"
                                                                v-if="attachment.progress==100 && attachment.error == ''">
                                                                {{attachment.progress}}%
                                                                Uploaded</div>
                                                            <div class="fw-500">
                                                                ({{attachment.size | prettyBytes}})
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- <div v-if="attachment.uploading || attachment.url == undefined"
                                                    class="pointer"
                                                    @click="deleteAttachment(attachment, index)">
                                                    <i
                                                        class="icon icon-close fs-16 closeAttachment"></i>
                                                </div>
                                                <div v-else class="pointer"
                                                    @click="deleteAttachment(attachment, index)">
                                                    <i
                                                        class="icon icon-close fs-16 closeAttachment"></i>
                                                </div> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex flex-wrap align-items-center justify-content-center mb-4 mt-5" v-if="campaign_details.status == 'pending'">
                                <!-- <button class="btn btn-new-cancel" @click ="rejectPopUp">Reject</button>
                                <button class="btn btn-new-save  ml-5" @click ="approvePopUp">Approve</button> -->
                                <button class="btn new-cancel-button" @click="gotoListView">Cancel</button>
                                <button class="btn new-save-button  ml-5" @click="ConfirmTemplate">View</button>
                            </div>
                            <div class="d-flex flex-wrap align-items-center justify-content-center mb-4 mt-5" v-else>
                                <button class="btn btn-new-secondary" @click="gotoListView">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <approve-campaign v-if="openApprovePopUp" modal_name="approveCampaign" @approveCampaigns="approveCampaigns" @cancelApprove="closeApprove"></approve-campaign>
        <reject-campaign v-if="openRejectPopUp" modal_name="rejectCampaign" @rejectCampaigns="rejectCampaigns" @cancelReject="closeReject"></reject-campaign>
        <sweet-modal ref="warning_modal" hide-close-button overlay-theme="dark" icon="warning">{{warning_msg}}</sweet-modal>
        <sweet-modal ref="success_modal" hide-close-button overlay-theme="dark" icon="success">{{success_msg}}</sweet-modal>
        <preview @hidePreview="hidePreview" v-if="preview_visible" :file_preview="preview_file"></preview>
        <!-- <contacts-modal v-if="openContactsPopUp" modal_name="contactsPopUp" @hide-contacts-modal="closeContactsModal()"></contacts-modal> -->
    </div>
</template>
<script>
import VueTagsInput from "@johmun/vue-tags-input";
import { HalfCircleSpinner } from "epic-spinners";
import moment from 'moment';
var mime = require('mime-types')
const Preview = () => import("../../Preview");
import countries from "../../json/countries.json";
import ApproveCampaign from "../../alertModals/ApproveCampaign";
import RejectCampaign from "../../alertModals/RejectCampaign";
import axios from "axios";
import customer from "../../mixins/customer"
import leads from "../../mixins/leads"
import campaign from "../../mixins/campaign"
import { SweetModal } from 'sweet-modal-vue';
// import { EventBus } from './eventBus/nav-bar-event';
import EmailTemplateOne from './EmailTemplateOne';
import EmailTemplateTwo from './EmailTemplateTwo';
import EmailTemplateThree from './EmailTemplateThree';
import { EventBus } from '../../eventBus/nav-bar-event';
const ContactsModal = () => import("./ContactsModal");
export default {
    data(){
        return {
            tags: [],
            tag: "",
            bindProps: {
                mode: "international",
                defaultCountry: "US"
            },
            phone_number: {
                number: "",
                code: "",
                country_code: ""
            },
            openApprovePopUp: false,
            openRejectPopUp: false,
            success_msg:"",
            warning_msg:"",
            isUploadingInProgress: false,
            openContactsPopUp: false,
            createJson:{
                author_name: "",
                author_email: "",
                campaign_name: "",
                campaign_type: "Email",
                //industry_type: "",
                start_date: moment(new Date().toUTCString()).format("YYYY-MM-DD"),
                start_time: moment(new Date().toUTCString()).format("HH:mm"),
                end_date: "",
                //end_time: "",
                recurrence_days: "",
                currency: "",
                budget: "",
                send_now: false,
                selectedtemplate: "advertised_yours",
                description: "",
                recipient_details: [],
                // topic_name: "",
                // headline_url: "",
                // add_url: "",
                // headline: "",
                // content: "",
                // street: "",
                // state: "",
                // city: "",
                // township: "",
                // pincode: "",
                // facebook_url: "",
                // twitter_url: "",
                // insta_url: "",
                // linkedin_url: "",
            },
            template_details:[{
                template_dates: [],
                topic_name: "",
                headline_url: "",
                add_url: "",
                headline: "",
                content: "",
                phone_number: {
                    number: "",
                    code: "",
                    country_code: ""
                },
                meeting_location_vmodel: "",
                location:{
                    address_type: "mailing_address",
                    building_number: "",
                    street:'',
                    city:'',
                    township:'',
                    state:'',
                    country:'',
                    zip_code:'',
                    latitude:'',
                    longitude:'',
                },
                facebook_url: "",
                twitter_url: "",
                insta_url: "",
                linkedin_url: "",
                logoImage: [],
                bannerImage: [],
                showLogoImageUpload: true,
                showBannerImageUpload: true,
            }],
            attachmentNew: [],
            // logoImage: [],
            // bannerImage: [],
            countries: countries,
            // location:{
            //     full_address: "",
            //     address_type: "mailing_address",
            //     address_description: "primary",
            //     street:'',
            //     city:'',
            //     township:'',
            //     country:'',
            //     zip_code:'',
            //     latitude:'',
            //     longitude:'',
            // },
           // meeting_location_vmodel: "",
            ajaxCallInProgress: false,
            // industries: ["Accommodation and Food Services",
            //     "Administrative and Support, Waste Management and Remediation Services",
            //     "Agriculture, Forestry, Fishing and Hunting", "Arts, Entertainment and Recreation",
            //     "Construction", "Educational Services", "Finance and Insurance", "F&B",
            //     "Health Care and Social Assistance", "Information and Cultural Industries",
            //     "Management of Companies and Enterprises", "Manufacturing",
            //     "Mining, Quarrying, and Oil and Gast Extraction",
            //     "Other Services (except public administration)",
            //     "Professional, Scientific and Technical Services", "Public Administration",
            //     "Real Estate and Rental and Leasing", "Retail Trade", "Transportation and Warehousing",
            //     "Utilities", "Wholesale Trade"
            // ],
            is_start_date: false,
            is_end_time:false,
            is_end_date: false,
            recurrencedays: ["Once", "Daily", "Weekly", "Monthly"],
            recurrence_nos: null,
            //recurrencenumbers: ["None", "Once", "Twice", "Thrice", "Every 4 hours", "Morning", "Evening"],
            search_term: "",
            optionsRecipients: [],
            isLoading: false,
            scrollableCustomer: false,
            limit: 10,
            search_term: "",
            search_key: "",
            total: 0,
            skip: 0,
            skip_count: 0,
            count: 0,
            isVisible: false,
            show_temp_data:false,
            selectedtemplate: 'advertised_yours',
            preview_file: '',
            preview_visible: false,
            campaign_details: [],
            campaign_id: "",
            image: {
                //url1: '/static/images/template-one-image.png',
                //url2: '/static/images/template-two-image.png',
                name: "template-three-image.webp",
                url: '/static/images/template3.webp',
            }
        }
    },
    mixins: [customer,leads,campaign],
    components:{
        EmailTemplateOne,
        EmailTemplateTwo,
        EmailTemplateThree,
        HalfCircleSpinner,
        Preview,
        ContactsModal,
        ApproveCampaign,
        RejectCampaign,
        SweetModal,
        VueTagsInput
    },
    methods:{
        gotoEdit(){
            this.$router.push('/campaign/email/editCampaignEmail/'+ this.$route.params.id);
        },
        ConfirmTemplate(){
            this.$router.push({
                path: "/campaign/email/previewTemplateThree/"+this.$route.params.id,
                query: {
                    from_approval_email: true
                }
            })
        },
        gotoListView(){
            this.$router.push('/campaign/email/campaignEmailListView/')
        },
        //Shows approve popup
        approvePopUp(){
            this.openApprovePopUp = true;
            setTimeout(()=>{
                this.$modal.show("approveCampaign")
            },500)
        },
        closeApprove(){
            this.openApprovePopUp = false;
        },
        //Shows reject popup
        rejectPopUp(){
            this.openRejectPopUp = true;
            setTimeout(()=>{
                this.$modal.show("rejectCampaign")
            },500)
        },
        closeReject(){
            this.openRejectPopUp = false;
        },
        //API call to approve campaign
        async approveCampaigns(reason){
            try{
                let params = {
                    campaign_id: this.$route.params.id,
                    status: "approved",
                    reason: reason
                }
                let response = await this.callApproveRejectCampaignAPI(params)
                if (response.status_id == 1) {
                    this.success_msg = response.response
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.closeApprove();
                        this.$router.push({
                            path: '/campaign/email/campaignEmailListView/'
                        })
                        this.$refs.success_modal.close();
                    }, 3000);
                } else {
                    this.warning_msg = response.reason
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            }catch(error){
                this.warning_msg = error.reason
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        //API call to reject campaign
        async rejectCampaigns(reason){
            try {
                let params = {
                    campaign_id: this.$route.params.id,
                    status: "rejected",
                    reason: reason
                }
                let response = await this.callApproveRejectCampaignAPI(params)
                if (response.status_id == 1) {
                    this.success_msg = response.response
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.closeReject();
                        this.$router.push({
                            path: '/campaign/email/campaignEmailListView/'
                        })
                        this.$refs.success_modal.close();
                    }, 3000);
                } else {
                    this.warning_msg = response.reason
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            }catch(error){
                this.warning_msg = error.reason
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        contactsPop(){
            this.openContactsPopUp = true;
            setTimeout(()=>{
                this.$modal.show("contactsPopUp")
            },500)
        },
        closeContactsModal(){
            this.openContactsPopUp = false;
        },
        // resetData(){
        //     this.location.state = '',
        //     this.location.city = '',
        //     this.location.township = '',
        //     this.location.zip_code = '',
        //     this.location.full_address = '',
        //     this.location.street = ''
        //     this.location.building_no = ''
        //     this.location.country = ''
        // },
        //Allocates address fields
        setPlace(place) {
            this.meeting_location_vmodel = place.formatted_address;
            this.showAddress = true;
            let currentPlace = place;
            let address = place.formatted_address.split(", ");
            this.createJson.meeting_location.street =
                address[address.length - 4] || "";
            this.createJson.meeting_location.township =
                address[address.length - 3] || "";
            this.createJson.meeting_location.city = address[address.length - 3] || "";
            let statezip = address[address.length - 2] ?
                address[address.length - 2].split(" ") : ["", ""];
            if (address[address.length - 1].includes("-")) {
                let countrySelected = address[address.length - 1].split(" - ");
                countrySelected.forEach(x => {
                    if (this.countries.includes(x)) {
                        this.createJson.meeting_location.country = x;
                    } else {
                        this.createJson.meeting_location.country = "";
                    }
                });
            } else {
                this.createJson.meeting_location.country = address[address.length - 1];
            }
            this.createJson.meeting_location.state = statezip[0].match(/^[a-zA-Z]+$/) ?
                statezip[0] :
                statezip[1].match(/^[a-zA-Z]+$/) ?
                statezip[1] :
                "";
            this.createJson.meeting_location.zip_code = statezip[0].match(/^[0-9]+$/) ?
                statezip[0] :
                statezip[1].match(/^[0-9]+$/) ?
                statezip[1] :
                "";
            // this.createJson.meeting_location.latitude = currentPlace.geometry.location.lat();
            // this.createJson.meeting_location.longitude = currentPlace.geometry.location.lng();
        },
        //Gets user's location based on long and latt values
        getLocation() {
            if (navigator.geolocation) {
                // timeout at 60000 milliseconds (60 seconds)
                var options = {
                    enableHighAccuracy: false,
                    timeout: 30000, // milliseconds (30 seconds)
                    maximumAge: 600000
                }; // milliseconds (10 minutes)
                navigator.geolocation.getCurrentPosition(
                    this.showLocation,
                    this.errorHandler,
                    options
                );
            } else {
                alert("Sorry, browser does not support geolocation");
            }
        },

        // saveCampaign(){
        //     this.$validator.validateAll().then(result => {
        //         // if(result == true){
        //         //     if(this.createJson.selectedtemplate == "template1"){
        //         //         EventBus.$emit("call_template1", this.createMainJsonData)
        //         //     }
        //         //     else if(this.createJson.selectedtemplate == "template2"){
        //         //         EventBus.$emit("call_template2", this.createMainJsonData)
        //         //     }
        //         //     else if(this.createJson.selectedtemplate == "template3"){
        //         //         EventBus.$emit("call_template3", this.createMainJsonData)
        //         //     }
        //         // }
        //         localStorage.setItem('email_template_data', JSON.stringify(this.createMainJsonData))
        //         if(this.$route.params.id){
        //             this.$router.push({
        //                 path: "/campaign/email/previewTemplateThree/"+this.$route.params.id
        //             })
        //         } else
        //         this.$router.push({
        //             path: "/campaign/email/previewTemplateThree/"
        //         })
        //         this.is_end_date = true;
        //         this.is_end_time = true;
        //     });
        // },
        //API call to load specific campaign by id
        async loadCampaignDetails(){
            this.ajaxCallInProgress = true
            let response = await this.getCampaignDetails(this.$route.params.id)
            this.campaign_details = response.response
            this.createJson.campaign_name = this.campaign_details.name
            this.createJson.author_name = this.campaign_details.author_name
            this.createJson.author_email = this.campaign_details.author_email
            this.createJson.send_now = this.campaign_details.send_now
            this.createJson.campaign_type = this.campaign_details.type
            this.createJson.start_date = this.campaign_details.start_date
            this.createJson.start_time = this.campaign_details.start_time
            this.createJson.end_date = this.campaign_details.end_date
            this.createJson.end_time = this.campaign_details.end_time
            this.createJson.recurrence_days = this.campaign_details.recurrence ? this.campaign_details.recurrence[0].toUpperCase() + this.campaign_details.recurrence.substring(1) : ""
            this.createJson.currency = this.campaign_details.budget.symbol
            this.createJson.budget = this.campaign_details.budget.value
            this.createJson.description = this.campaign_details.description
            this.attachmentNew = this.campaign_details.attachments
            this.createJson.recipient_details = this.campaign_details.recipients
            if(this.campaign_details.other_recipients != null){
                this.tags = this.campaign_details.other_recipients
                if(this.tags){
                    this.tags.forEach(y => {
                        y.text = y.email
                    });
                }
            }
            this.campaign_details.template_details.forEach((data_bind, data_bind_index) => {
                if(data_bind_index == 0){
                    this.template_details[data_bind_index].template_dates = data_bind.email_dates
                    this.template_details[data_bind_index].topic_name = data_bind.info.topic_name
                    this.template_details[data_bind_index].headline_url = data_bind.info.url_headline
                    this.template_details[data_bind_index].add_url = data_bind.info.url
                    this.template_details[data_bind_index].headline = data_bind.info.headline_name
                    this.template_details[data_bind_index].content = data_bind.info.headline_content
                    this.template_details[data_bind_index].phone_number = data_bind.phone_number
                    this.template_details[data_bind_index].location = data_bind.address
                    this.template_details[data_bind_index].facebook_url = data_bind.social_media.facebook
                    this.template_details[data_bind_index].insta_url = data_bind.social_media.instagram
                    this.template_details[data_bind_index].linkedin_url = data_bind.social_media.linkedin
                    this.template_details[data_bind_index].twitter_url = data_bind.social_media.twitter
                    if(data_bind.images.logo != ""){
                        this.template_details[data_bind_index].showLogoImageUpload = false
                        this.template_details[data_bind_index].logoImage.push({
                            name: data_bind.images.logo.slice(data_bind.images.logo.length - 20),
                            size: 0,
                            url: data_bind.images.logo
                        })
                    }
                    if(data_bind.images.banner_image != ""){
                        this.template_details[data_bind_index].showBannerImageUpload = false
                        this.template_details[data_bind_index].bannerImage.push({
                            name: data_bind.images.banner_image.slice(data_bind.images.banner_image.length - 20),
                            size: 0,
                            url: data_bind.images.banner_image
                        })
                    }
                    this.template_details[data_bind_index].meeting_location_vmodel =
                    (this.template_details[data_bind_index].location.street ? this.template_details[data_bind_index].location.street + ', ' : '') +
                    (this.template_details[data_bind_index].location.township ? this.template_details[data_bind_index].location.township + ', ' : '') +
                    (this.template_details[data_bind_index].location.city ? this.template_details[data_bind_index].location.city + ', ' : '') +
                    (this.template_details[data_bind_index].location.state ? this.template_details[data_bind_index].location.state + ', ' : '') +
                    (this.template_details[data_bind_index].location.zip_code ? this.template_details[data_bind_index].location.zip_code + ', ' : '') +
                    (this.template_details[data_bind_index].location.country ? this.template_details[data_bind_index].location.country + '.' : '')
                } else if(data_bind_index > 0){
                    let logoImage = []
                    let bannerImage = []
                    let showLogoImageUpload = true
                    let showBannerImageUpload = true
                    let meeting_location_vmodel = ""
                    if(data_bind.images.logo != ""){
                        logoImage.push({
                            name: data_bind.images.logo.slice(data_bind.images.logo.length - 20),
                            size: 0,
                            url: data_bind.images.logo
                        })
                        showLogoImageUpload = false
                    }
                    if(data_bind.images.banner_image != ""){
                        bannerImage.push({
                            name: data_bind.images.banner_image.slice(data_bind.images.banner_image.length - 20),
                            size: 0,
                            url: data_bind.images.banner_image
                        })
                        showBannerImageUpload = false
                    }
                    meeting_location_vmodel = 
                    (data_bind.address.street ? data_bind.address.street + ', ': '') +
                    (data_bind.address.township ? data_bind.address.township + ', ': '') +
                    (data_bind.address.city ? data_bind.address.city + ', ': '') +
                    (data_bind.address.state ? data_bind.address.state + ', ': '') +
                    (data_bind.address.country ? data_bind.address.country + ', ': '') +
                    (data_bind.address.zip_code ? data_bind.address.zip_code : '')

                    this.template_details.push({
                        template_dates: data_bind.email_dates,
                        topic_name: data_bind.info.topic_name,
                        headline_url: data_bind.info.url_headline,
                        add_url: data_bind.info.url,
                        headline: data_bind.info.headline_name,
                        content: data_bind.info.headline_content,
                        phone_number: data_bind.phone_number,
                        meeting_location_vmodel: meeting_location_vmodel,
                        location:data_bind.address,
                        facebook_url: data_bind.social_media.facebook,
                        twitter_url: data_bind.social_media.twitter,
                        insta_url: data_bind.social_media.instagram,
                        linkedin_url: data_bind.social_media.linkedin,
                        logoImage: logoImage,
                        bannerImage: bannerImage,
                        showLogoImageUpload: showLogoImageUpload,
                        showBannerImageUpload: showBannerImageUpload,
                    })
                }
            })
            // this.createJson.topic_name = this.campaign_details.template_details.info.topic_name,
            // this.createJson.headline_url = this.campaign_details.template_details.info.url_headline,
            // this.createJson.add_url = this.campaign_details.template_details.info.url,
            // this.createJson.headline = this.campaign_details.template_details.info.headline_name,
            // this.createJson.content = this.campaign_details.template_details.info.headline_content,
            // this.createJson.meeting_location_vmodel = this.campaign_details.template_details.meeting_location_vmodel,
            // this.createJson.street = this.campaign_details.template_details.address.street,
            // this.location.country = this.campaign_details.template_details.address.country,
            // this.createJson.state = this.campaign_details.template_details.address.state,
            // this.createJson.city = this.campaign_details.template_details.address.city,
            // this.createJson.township = this.campaign_details.template_details.address.township,
            // this.createJson.pincode = this.campaign_details.template_details.address.zip_code,
            // this.createJson.facebook_url = this.campaign_details.template_details.social_media.facebook,
            // this.createJson.twitter_url = this.campaign_details.template_details.social_media.twitter,
            // this.createJson.insta_url = this.campaign_details.template_details.social_media.instagram,
            // this.createJson.linkedin_url = this.campaign_details.template_details.social_media.linkedin,
            // this.phone_number = this.campaign_details.template_details.phone_number
            // if(this.campaign_details.template_details.images.logo != ""){
            //     this.logoImage.push({
            //         name: this.campaign_details.template_details.images.logo.slice(this.campaign_details.template_details.images.logo.length - 20),
            //         size: 0,
            //         url: this.campaign_details.template_details.images.logo
            //     })
            // }
            // if(this.campaign_details.template_details.images.banner_image != ""){
            //     this.bannerImage.push({
            //         name: this.campaign_details.template_details.images.banner_image.slice(this.campaign_details.template_details.images.banner_image.length - 20),
            //         size: 0,
            //         url: this.campaign_details.template_details.images.banner_image
            //     })
            // }
            // this.meeting_location_vmodel =
            //     (this.createJson.street ? this.createJson.street + ', ' : '') +
            //     (this.createJson.township ? this.createJson.township + ', ' : '') +
            //     (this.createJson.city ? this.createJson.city + ', ' : '') +
            //     (this.createJson.state ? this.createJson.state + ', ' : '') +
            //     (this.createJson.pincode ? this.createJson.pincode + ', ' : '') +
            //     (this.location.country ? this.location.country + ', ' : '')
            //EventBus.$emit("edit_template_three_data", this.campaign_details.template_details)
            this.ajaxCallInProgress = false
        },
        showTempData(){
            this.show_temp_data = true
            setTimeout(() => {
                this.$modal.show("templateData")
            }, 500);
        },
        hideTempData(){
            this.show_temp_data = false
        },
        addCustomer(newTag) {
            const element = newTag;
            if (String(element).match(this.email_regex)) {
                this.optionsRecipients.push({
                    email: element
                });
                this.createJson.recipient_email.push({
                    email: element
                });
            } else {
                this.$awn.success("As Your Email ID Was Not Valid It is Removed");
                this.invalidEmail = true;
                return;
            }
        },
        hidePreview(){
            this.preview_visible = false
        },
        previewImage(file) {
            let content_type = mime.lookup(file.name) ? mime.lookup(file.name) : 'application/octet-stream';
            file['content_type'] = content_type;
            this.preview_file = file;
            this.preview_visible = true;
        },
        async searchCustomerInside(key) {
            if (key) {
                this.search_term = key;
            }
            let params = {
                skip: this.skip,
                limit: this.limit,
                search_key: this.search_term,
                company_id: this.loggedInUser.company_id
            };
            let res = await this.getAssigned(params);
            this.optionsRecipients = res.response;
            this.count = 0;
            this.isLoading = false;
        },
        async reachedEndOfListCustomer(reached) {
            this.isVisible = reached;
            if (reached) {
                if (this.scrollableCustomer == false) {
                    this.isLoading = true;
                    let res = await this.getAssigned({
                        skip: this.optionsRecipients.length,
                        limit: 10,
                        search_key: this.search_term,
                        company_id: this.loggedInUser.company_id
                    });
                    if (res.response.length > 0) {
                        let tempFiles = res.response;
                        tempFiles.forEach(el => {
                            this.optionsRecipients.push(
                                el);
                        });
                        this.count += res.response.length;
                        this.isLoading = false;
                    } else {
                        this.scrollableCustomer = true;
                        this.isLoading = false;
                    }
                    this.isLoading = false;
                }
            }
        },
        deleteLogo(attachment, index) {
            this.logoImage.splice(index, 1);
        },
        deleteBannerImage(attachment, index) {
            this.bannerImage.splice(index, 1);
        },
        dropHandlerLogo(evt) {
            // Prevent default behavior (Prevent file from being opened)
            evt.preventDefault();
            // Use DataTransfer interface to access the file(s)
            [...evt.dataTransfer.files].forEach((file, i) => {
                this.uploadLogoImageFromDrop(file)
            });
        },
        dragOverHandlerLogo(evt) {
            // Prevent default behavior (Prevent file from being opened)
            evt.preventDefault();
        },
        uploadLogoImageFromDrop(event) {
            if(event) {
                var input = event;
            }
            if (input && event) {
                const CancelToken = axios.CancelToken;
                const source = CancelToken.source();
                let attachment = {
                    //id: uuidv4(),
                    name: input.name,
                    size: JSON.stringify(input.size),
                    source: source,
                    progress: 0,
                    created_time: new Date(),
                    error: ""
                }
                this.logoImage.push(attachment)
                this.getResumableInsideURL(input, this.logoImage[this.logoImage.length - 1]);
            }
        },
        getResumableInsideURL(file, attachment) {
            this.isUploadingInProgress = true;
            let usage_type = {
                usage: "attachment"
            }
            let data = {
                file: attachment.name
            }
            data = new FormData()
            data.append('file',file)
            Object.keys(usage_type).map(e => {
                data.append(e, JSON.stringify(usage_type[e]))
            })
            axios.post('https://cloudapis.digicollect.com/external/upload_file', data,{
                onUploadProgress: function (progressEvent) {
                    let progress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
                    if (progress < 100) {
                        attachment.progress = progress;
                    }
                }.bind(this)
            })
            .then(response => {
                let resumable_url = response.data.url;
                attachment.url = resumable_url;
                attachment.progress = 100;
                attachment.uploading = false;
                this.isUploadingInProgress = false;
                this.uploadFileToUpload(resumable_url,file,attachment)
                if (response.data.hasOwnProperty('reason')){
                    attachment.error = "Error Uploading"
                    if (attachment.url == undefined) {
                        this.check_attachments = true
                    } else {
                        this.check_attachments = false
                    }
                }
            })
            .catch(error => {
                // this.error = "Error Uploading"
            })
        },
        uploadLogoImage(event) {
            if(event) {
                var input = event.target;
            }
            if(event == undefined) {
                var input
                input = this.$refs.upload_inside.files
                input['files'] = []
                input.files.push({
                    lastModified : input[0].file.lastModified,
                    name : input[0].file.name,
                    size : input[0].file.size,
                    type : input[0].file.type,
                    webkitRelativePath : input[0].file.webkitRelativePath,
                    lastModifiedDate : input[0].file.lastModifiedDate
                })
                const CancelToken = axios.CancelToken;
                const source = CancelToken.source();
                let attachment = {
                    //id: uuidv4(),
                    name: input.files[0].name,
                    size: JSON.stringify(input.files[0].size),
                    source: source,
                    progress: 0,
                    created_time: new Date(),
                    error: "",
                    url:""
                }
                this.logoImage.push(attachment)
                this.getResumableInsideURL(input[0].file, this.logoImage[this.logoImage.length - 1]);

            }
            if (input.files && input.files[0] && event) {
                const CancelToken = axios.CancelToken;
                const source = CancelToken.source();
                let attachment = {
                    //id: uuidv4(),
                    name: input.files[0].name,
                    size: JSON.stringify(input.files[0].size),
                    source: source,
                    progress: 0,
                    created_time: new Date(),
                    error: ""
                }
                this.logoImage.push(attachment)
                this.getResumableInsideURL(input.files[0], this.logoImage[this.logoImage.length - 1]);
            }
        },
        dropHandlerBanner(evt) {
            // Prevent default behavior (Prevent file from being opened)
            evt.preventDefault();
            // Use DataTransfer interface to access the file(s)
            [...evt.dataTransfer.files].forEach((file, i) => {
                this.uploadBannerImageFromDrop(file)
            });
        },
        dragOverHandlerBanner(evt) {
            // Prevent default behavior (Prevent file from being opened)
            evt.preventDefault();
        },
        uploadBannerImageFromDrop(event) {
            if(event) {
                var input = event;
            }
            if (input && event) {
                const CancelToken = axios.CancelToken;
                const source = CancelToken.source();
                let attachment = {
                    //id: uuidv4(),
                    name: input.name,
                    size: JSON.stringify(input.size),
                    source: source,
                    progress: 0,
                    created_time: new Date(),
                    error: ""
                }
                this.bannerImage.push(attachment)
                this.getResumableURL(input, this.bannerImage[this.bannerImage.length - 1]);
            }
        },
        getResumableURL(file, attachment) {
            this.isUploadingInProgress = true;
            attachment.uploading = true;
            let usage_type = {
                usage: "attachment"
            }
            let data = {
                file: attachment.name
            }
            data = new FormData()
            data.append('file',file)
            Object.keys(usage_type).map(e => {
                data.append(e, JSON.stringify(usage_type[e]))
            })
            this.$http.post('https://cloudapis.digicollect.com/external/upload_file', data,{
                onUploadProgress: function (progressEvent) {
                    let progress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
                    if (progress < 100) {
                        attachment.progress = progress;
                    }
                }.bind(this)
            })
            .then(response => {
                let resumable_url = response.data.url;
                attachment.url = resumable_url;
                attachment.progress = 100;
                attachment.uploading = false;
                this.isUploadingInProgress = false;
                delete attachment['source'];
            })
            .catch(error => {

            })
        },
        uploadBannerImage(event) {
            if(event) {
                var input = event.target;
            }
            if(event == undefined) {
                var input
                input = this.$refs.upload.files
                input['files'] = []
                input.files.push({
                    lastModified : input[0].file.lastModified,
                    name : input[0].file.name,
                    size : input[0].file.size,
                    type : input[0].file.type,
                    webkitRelativePath : input[0].file.webkitRelativePath,
                    lastModifiedDate : input[0].file.lastModifiedDate
                })
                const CancelToken = axios.CancelToken;
                const source = CancelToken.source();
                let attachment = {
                    //id: uuidv4(),
                    name: input.files[0].name,
                    size: JSON.stringify(input.files[0].size),
                    source: source,
                    progress: 0,
                    created_time: new Date(),
                    error: "",
                    url:""
                }
                this.bannerImage.push(attachment)
                this.getResumableURL(input[0].file, this.bannerImage[this.bannerImage.length - 1]);
            }
            if (input.files && input.files[0] && event) {
                const CancelToken = axios.CancelToken;
                const source = CancelToken.source();
                let attachment = {
                    //id: uuidv4(),
                    name: input.files[0].name,
                    size: JSON.stringify(input.files[0].size),
                    source: source,
                    progress: 0,
                    created_time: new Date(),
                    error: ""
                }
                this.bannerImage.push(attachment)
                this.getResumableURL(input.files[0], this.bannerImage[this.bannerImage.length - 1]);
            }
        },
    },
    mounted(){
        this.createJson.author_name = this.loggedInUser.full_name;
        this.createJson.author_email = this.loggedInUser.login_id;
        if(localStorage.getItem("email_template_data")){
            let email_template_data = JSON.parse(localStorage.getItem("email_template_data"))
            this.createJson.campaign_name = email_template_data.campaign_name
            this.createJson.author_name = email_template_data.author_name
            this.createJson.author_email = email_template_data.author_email
            this.createJson.send_now = email_template_data.send_now
            this.createJson.campaign_type = email_template_data.campaign_type
            this.createJson.start_date = email_template_data.start_date
            this.createJson.start_time = email_template_data.start_time
            this.createJson.end_date = email_template_data.end_date
            this.createJson.end_time = email_template_data.end_time
            this.createJson.recurrence_days = email_template_data.recurrence_days
            this.createJson.budget = email_template_data.budget
            this.createJson.description = email_template_data.description
            this.createJson.recipient_details = email_template_data.recipient_details
            this.createJson.selectedtemplate = email_template_data.selectedtemplate
            if(email_template_data.other_recipients != null){
                this.tags = email_template_data.other_recipients
                if(this.tags){
                    this.tags.forEach(x => {
                        x.text = x.email
                    });
                }
            }
            // this.createJson.topic_name = email_template_data.topic_name,
            // this.createJson.headline_url = email_template_data.headline_url,
            // this.createJson.add_url = email_template_data.add_url,
            // this.createJson.headline = email_template_data.headline,
            // this.createJson.content = email_template_data.content,
            // this.createJson.meeting_location_vmodel = email_template_data.meeting_location_vmodel,
            // this.createJson.street = email_template_data.address,
            // this.location.country = email_template_data.country,
            // this.createJson.state = email_template_data.state,
            // this.createJson.city = email_template_data.city,
            // this.createJson.township = email_template_data.township,
            // this.createJson.pincode = email_template_data.pincode,
            // this.createJson.facebook_url = email_template_data.facebook_url,
            // this.createJson.twitter_url = email_template_data.twitter_url,
            // this.createJson.insta_url = email_template_data.insta_url,
            // this.createJson.linkedin_url = email_template_data.linkedin_url
            this.$forceUpdate()
        }
        if(this.$route.params.id){
            this.campaign_id = this.$route.params.id
            this.loadCampaignDetails()
        }
    },
    computed: {
        loggedInUser() {
            return this.$store.state.loggedInUser;
        },
        current_date() {
            var date = new Date();
            date.setDate(date.getDate() + 1);
            return date;
        },
        userPermissions(){
            return this.$store.getters.userPermissions;
        },
        // createMainJsonData(){
        //     return {
        //         campaign_name: this.createJson.campaign_name,
        //         author_name: this.createJson.author_name,
        //         author_email: this.createJson.author_email,
        //         industry_type: this.createJson.industry_type,
        //         campaign_type: this.createJson.campaign_type,
        //         start_date: this.createJson.start_date,
        //         start_time: this.createJson.start_time,
        //         end_date: this.createJson.end_date,
        //         end_time: this.createJson.end_time,
        //         recurrence_days: this.createJson.recurrence_days,
        //         budget: this.createJson.budget,
        //         description: this.createJson.description,
        //         recipient_details: this.createJson.recipient_details,
        //         selectedtemplate: this.createJson.selectedtemplate,
        //         topic_name: this.createJson.topic_name,
        //         headline_url: this.createJson.headline_url,
        //         add_url: this.createJson.add_url,
        //         headline: this.createJson.headline,
        //         content: this.createJson.content,
        //         meeting_location_vmodel: this.createJson.meeting_location_vmodel,
        //         address: this.createJson.street,
        //         country: this.location.country,
        //         state: this.createJson.state,
        //         city: this.createJson.city,
        //         township: this.createJson.township,
        //         pincode: this.createJson.pincode,
        //         facebook_url: this.createJson.facebook_url,
        //         twitter_url: this.createJson.twitter_url,
        //         insta_url: this.createJson.insta_url,
        //         linkedin_url: this.createJson.linkedin_url
        //     }
        //},
    },
    created() {
    },
}
</script>
<style scoped>
    .add-new-field{
        background-color: transparent;
        outline: 0 none !important;
    }
    .main-div {
        background: #fff;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .create-company-container {
        background-color: #fff;
        padding: 0px 0 0px 0;
        border-radius: 5px;
    }

    .create-company-header {
        padding: 9.9px 15px;
        background-color: #00448b;
    }
    .input-label {
        font-weight: 600;
        line-height: 1.5;
        letter-spacing: 0.39px;
        text-align: left;
        color: #00448b;
        padding: 0 0 6px 0px;
        font-size: 14px;
    }
    .input-field {
        border-radius: 6px !important;
        border: solid 0.5px #3f3f3f;
        background-color: #fff;
        padding: 8px 10px;
        width: 100% !important;
        height: 40px;
        color: black;
        font-size: 14px !important;
        font-weight: 600;
    }
    .input-width {
        border-radius: 5px !important;
        border: solid 0.5px #3f3f3f;
        background-color: #fff;
        padding: 8px 10px;
        width: 100% !important;
        height: 40px !important;
    }
    .btn-new-cancel {
        color: #fff;
        background-color: #E64646;
        border-radius: 5px;
        text-transform: none;
        font-weight: 500;
        border: 2px solid #E64646;
        line-height: 30px;
        box-shadow: none;
    }

    .btn-new-secondary{
        color: #fff;
        background-color: #00448b;
        border-radius: 5px;
        text-transform: none;
        font-weight: 500;
        border: 2px solid #00448b;
        line-height: 30px;
        box-shadow: none;
    }
    .btn-new-save {
        border: 2px solid #1f8122;
        color:#fff;
        line-height: 30px;
        border-radius: 5px;
        background-color: #1f8122;
        text-transform: capitalize;
    }

    .text-capitalize{
        text-transform: capitalize !important;
    }
    .mx-datepicker.date-white .mx-input-wrapper input.mx-input {
        height: 32px !important;
        color: #fff !important;
        font-weight: 600 !important;
        font-size: 13px !important;
    }
    .mx-input {
        display: inline-block;
        height: 0px !important;
    }
    .v-hidden {
        visibility: hidden;
    }

    i,
    [class^="icon-"] {
        line-height: 0px !important;
    }
    .text-green {
        color: #008a63 !important;
    }
    .pointer-event {
        background-color: #fff !important;
    }
    .text-secondary {
        color: #00448b !important;
    }
    .text-line {
        text-decoration :none !important;
    }
    .recipients-box {
        border-radius: 5px;
        width: 100%;
        height:auto;
        overflow:scroll;
        max-height:500px;
    }
    .custom-control {
        position: relative;
        display: block;
        min-height: 1.5rem;
        padding-left: 1.5rem;
    }
    .custom-control.image-checkbox {
        position: relative;
        padding-left: 0;
        border: 1px solid #005dae;
        border-radius: 10px;
        width: 150px;
    }
    .custom-control-input {
        position: absolute;
        z-index: -1;
        opacity: 0;
        right: 0px;
    }
    input.custom-control-input[type=radio], input.custom-control-input[type=radio] {
        box-sizing: border-box;
        padding: 0;
    }
    .custom-control-label-image {
        position: relative;
        margin-bottom: 0;
        vertical-align: top;
    }
    .custom-control.image-checkbox label {
        cursor: pointer;
        padding: 5px;
        height: 136px;
    }
    .custom-control-label-image::before {
        position: absolute;
        top: 5px;
        right: -1.5rem;
        display: block;
        width: 1.8rem;
        height: 1.8rem;
        pointer-events: none;
        content: "";
        background-color: #fff;
        border: #adb5bd solid 2px;
    }
    .custom-control-label-image::after {
        position: absolute;
        top: 5px;
        right: -1.5rem;
        display: block;
        width: 1.8rem;
        height: 1.8rem;
        content: "";
        background: no-repeat 50%/50% 50%;
    }
    .custom-control-label-image::before, .custom-file-label, .custom-select {
        transition: background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    }
    .custom-checkbox-image .custom-control-label-image::before {
        border-radius: 4px;
    }
    .custom-control.image-checkbox label:before {
        border-color: #adb5bd;
        background-color: transparent;
        display: none;
    }
    .custom-control.image-checkbox label:after {
        transition: opacity .3s ease;
        opacity: 0;
        display: none;
        right: 4px;
        z-index: 1;
    }
    .custom-control.image-checkbox label:before {
        transition: opacity .3s ease;
        opacity: 1;
        right: 4px;
        z-index: 1;
    }
    .custom-control-input:checked~.custom-control-label-image::before {
        color: #fff;
        border-color: #007bff;
        background-color: #007bff;
    }
    .custom-checkbox-image .custom-control-input:checked~.custom-control-label-image::after {
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3e%3c/svg%3e");
    }
    .custom-control.image-checkbox .custom-control-input:checked ~ .custom-control-label-image:after, .custom-control.image-checkbox .custom-control-input:checked ~ .custom-control-label-image:before {
        opacity: 0;
    }
    .custom-control.image-checkbox label img {
        border-radius: 2.5px;
    }
    .h-label{
        padding-right:10px;
        font-weight: 600;
        line-height: 1.5;
        letter-spacing: 0.39px;
        text-align: left;
        color: #00448b;
        font-size: 14px;
        background-color: #f8f8f8 !important;
    }
    .h-line{
        height: 12px;
        border-bottom: 2px solid #ccc;
        text-align: left
    }
    .icon-data{
        padding-left: 30px;
        background-size: 20px !important;
        background-position: 2% 42% !important;
        font-family: 'Poppins', sans-serif !important;
    }
    .icon-face-link {
        background: url("https://storage.googleapis.com/5e8dbf9ac9ece9d5bf0786f0/598b84ab-f2be-40a0-a1d6-bed8c747a012.png") no-repeat left;
        padding-left: 40px;
    }
    .icon-insta-link {
        background: url("https://storage.googleapis.com/5e8dbf9ac9ece9d5bf0786f0/efb3d282-9581-4712-9bd8-e897eadec524.png") no-repeat left;
        padding-left: 40px;
    }
    .icon-twit-link {
        background: url("https://storage.googleapis.com/5e8dbf9ac9ece9d5bf0786f0/07397637-cd28-4f17-8e55-b1a233a0613e.png") no-repeat left;
        padding-left: 40px;
    }
    .icon-link {
        background: url("https://storage.googleapis.com/5e8dbf9ac9ece9d5bf0786f0/68ed13c1-1fae-4803-b032-7feec568de10.png") no-repeat left;
        padding-left: 40px;
    }
    .custom-control:hover .img {
        opacity: 0.3;
    }

    .custom-control:hover .middle {
        opacity: 1;
    }
    .img {
        opacity: 1;
        display: block;
        width: 140px;
        height: 130px;
        transition: .5s ease;
        backface-visibility: hidden;
    }
    .middle {
        transition: .5s ease;
        opacity: 0;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        text-align: center;
    }
    .icon-css{
        color:#000;
        width:24px !important;
        z-index: 99;
    }
    .outer-checkbox{
        width: 100%;
        position: absolute;
        transform: translate(-50%, -50%);
        top: 50%;
        left: 50%;
        display: grid;
        place-items: center;
    }
    .inner-checkbox{
        height: 200px;
        width: 200px;
        background-color: #fff;
        box-shadow: 0 0 25px rgba(17, 1, 68, 0.08);
        border-radius: 8px;
        position: relative;
        cursor: pointer;
    }
    .templateimage-name {
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.56;
        letter-spacing: 0.69px;
        text-align: left;
        color: #261212;
        text-align: center;
        margin-top: 8px;
    }
    .add-button{
        color: #226BD3;
        background-color: #fff;
        font-weight: 600;
        cursor: pointer;
    }
    .choose-file{
        color: #0375F3;
        font-weight: 600;
        font-size: 14px;
    }
    .btn-pending{
        background: #E4A045 !important;
        border-radius: 5px !important;
        cursor: text !important;
    }
    .btn-approved{
        background: #078A63 !important;
        border-radius: 5px !important;
        cursor: text !important;
    }
    .btn-rejected{
        background: #E64646 !important;
        border-radius: 5px !important;
        cursor: text !important;
    }

    .custom__tag {
        align-items: end !important;
    }

    .text-new-danger{
        color: #e64646 !important;
    }

    .text-pending{
        color: #E4A045 !important;
    }

    .text-approved{
        color: #078A63 !important
    }
    .content-details-div{
        background-color: #f8f8f8 !important;
        padding: 0px 30px;
        margin-top: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Campaign/Email/ApproveEmail.vue